
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import './assets/main.css'
import axios from 'axios'
import { useAuthStore } from './stores/auth'
import GlobalNotification from './components/GlobalNotification.vue'
import i18n from './i18n'
import * as Sentry from '@sentry/vue'
import Clarity from '@microsoft/clarity'

// Dodaj zmienną środowiskową do window dla dostępu z HTML
window.__VITE_ENABLE_ANALYTICS__ = import.meta.env.VITE_ENABLE_ANALYTICS


// Routes
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('./views/home/Home.vue')
  },
  {
    path: '/offers',
    name: 'Offers',
    component: () => import('./views/offer/Offers.vue'),
    props: { mainCategory: 'Samochody' },
    meta: { componentKey: 'offers-cars' }
  },
  {
    path: '/offers-quads',
    name: 'OffersQuads',
    component: () => import('./views/offer/Offers.vue'),
    props: { mainCategory: 'Quady' },
    meta: { componentKey: 'offers-quads' }
  },
  {
    path: '/offers/:brand',
    name: 'OffersByBrand',
    component: () => import('./views/offer/Offers.vue'),
    meta: { componentKey: 'offers-cars' }
  },
  {
    path: '/offers-quads/:brand',
    name: 'OffersQuadsByBrand',
    component: () => import('./views/offer/Offers.vue'),
    props: { mainCategory: 'Quady' },
    meta: { componentKey: 'offers-quads' }
  },
  {
    path: '/offers/:brand/:models',
    name: 'OffersByBrandAndModels',
    component: () => import('./views/offer/Offers.vue'),
    meta: { componentKey: 'offers-cars' }
  },
  {
    path: '/offers-quads/:brand/:models',
    name: 'OffersQuadsByBrandAndModels',
    component: () => import('./views/offer/Offers.vue'),
    props: { mainCategory: 'Quady' },
    meta: { componentKey: 'offers-quads' }
  },
  {
    path: '/offers-tires',
    name: 'OffersTires',
    component: () => import('./views/offer/OffersOthers.vue'),
    props: { mainCategory: 'Opony i Felgi' },
    meta: { componentKey: 'offers-tires' }
  },
  {
    path: '/offers-tires/:subCategory',
    name: 'OffersTiresBySubCategory',
    component: () => import('./views/offer/OffersOthers.vue'),
    props: { mainCategory: 'Opony i Felgi' },
    meta: { componentKey: 'offers-tires' }
  },
  {
    path: '/offers-tires/:subCategory/:subSubCategory',
    name: 'OffersTiresBySubCategoryAndSubSubCategory',
    component: () => import('./views/offer/OffersOthers.vue'),
    props: { mainCategory: 'Opony i Felgi' },
    meta: { componentKey: 'offers-tires' }
  },
  {
    path: '/offers-accessories',
    name: 'OffersAccessories',
    component: () => import('./views/offer/OffersOthers.vue'),
    props: { mainCategory: 'Akcesoria' },
    meta: { componentKey: 'offers-accessories' }
  },
  {
    path: '/offers-accessories/:subCategory',
    name: 'OffersAccessoriesBySubCategory',
    component: () => import('./views/offer/OffersOthers.vue'),
    props: { mainCategory: 'Akcesoria' },
    meta: { componentKey: 'offers-accessories' }
  },
  {
    path: '/offers-accessories/:subCategory/:subSubCategory',
    name: 'OffersAccessoriesBySubCategoryAndSubSubCategory',
    component: () => import('./views/offer/OffersOthers.vue'),
    props: { mainCategory: 'Akcesoria' },
    meta: { componentKey: 'offers-accessories' }
  },
  {
    path: '/offers-parts',
    name: 'OffersParts',
    component: () => import('./views/offer/OffersOthers.vue'),
    props: { mainCategory: 'Części' },
    meta: { componentKey: 'offers-parts' }
  },
  {
    path: '/offers-parts/:subCategory',
    name: 'OffersPartsBySubCategory',
    component: () => import('./views/offer/OffersOthers.vue'),
    props: { mainCategory: 'Części' },
    meta: { componentKey: 'offers-parts' }
  },
  {
    path: '/offers-parts/:subCategory/:subSubCategory',
    name: 'OffersPartsBySubCategoryAndSubSubCategory',
    component: () => import('./views/offer/OffersOthers.vue'),
    props: { mainCategory: 'Części' },
    meta: { componentKey: 'offers-parts' }
  },
  {
    path: '/offers-services',
    name: 'OffersServices',
    component: () => import('./views/offer/OffersOthers.vue'),
    props: { mainCategory: 'Usługi' },
    meta: { componentKey: 'offers-services' }
  },
  {
    path: '/offers-services/:subCategory',
    name: 'OffersServicesBySubCategory',
    component: () => import('./views/offer/OffersOthers.vue'),
    props: { mainCategory: 'Usługi' },
    meta: { componentKey: 'offers-services' }
  },
  {
    path: '/offers-services/:subCategory/:subSubCategory',
    name: 'OffersServicesBySubCategoryAndSubSubCategory',
    component: () => import('./views/offer/OffersOthers.vue'),
    props: { mainCategory: 'Usługi' },
    meta: { componentKey: 'offers-services' }
  },
  {
    path: '/offer/:slug',
    name: 'OfferDetails',
    component: () => import('./views/offer/OfferDetails.vue')
  },
  {
    path: '/offer/:id/edit',
    name: 'EditOffer',
    component: () => import('./views/offer/EditOffer.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/about',
    component: () => import('./views/home/About.vue')
  },
  {
    path: '/faq',
    component: () => import('./views/home/FAQ.vue')
  },
  {
    path: '/add-offer',
    component: () => import('./views/offer/AddOfferNew.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/register',
    component: () => import('./views/register/Register.vue')
  },
  {
    path: '/login',
    component: () => import('./views/auth/Login.vue')
  },
  {
    path: '/forgot-password',
    component: () => import('./views/auth/ForgotPassword.vue')
  },
  {
    path: '/reset-password',
    component: () => import('./views/auth/ResetPassword.vue')
  },
  {
    path: '/register/verification',
    component: () => import('./views/register/RegisterVerification.vue')
  },
  {
    path: '/profile',
    component: () => import('./views/profile/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile/settings',
    component: () => import('./views/profile/Settings.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/my-offers',
    name: 'UserOffers',
    component: () => import('./views/profile/UserOffers.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile/messages',
    name: 'Messages',
    component: () => import('./views/profile/Messages.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: () => import('./views/Favorites.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/comparison',
    name: 'Comparison',
    component: () => import('./views/Comparison.vue')
  },
  {
    path: '/wiki',
    name: 'Wiki',
    component: () => import('./views/wiki/Categories.vue')
  },
  {
    path: '/wiki/:brand/:model/:id',
    name: 'ModelDetails',
    component: () => import('./views/wiki/ModelDetails.vue')
  },
  {
    path: '/privacy-policy',
    component: () => import('./views/home/PrivacyPolicy.vue')
  },
  {
    path: '/terms-of-service',
    component: () => import('./views/home/TermsOfService.vue')
  },
  {
    path: '/pricing',
    component: () => import('./views/home/Pricing.vue')
  },
  {
    path: '/partner-promotion-terms',
    component: () => import('./views/home/PartnerPromotionTerms.vue')
  },
  {
    path: '/data-deletion',
    component: () => import('./views/home/DataDeletion.vue')
  },
  {
    path: '/partnership',
    component: () => import('./views/home/Partnership.vue')
  },
  {
    path: '/activation/:offerId',
    name: 'Activation',
    component: () => import('./views/activation/Activation.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/activation/:slug/activate',
    name: 'ActivationBySlug',
    component: () => import('./views/activation/Activation.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/activation/success',
    name: 'ActivationSuccess',
    component: () => import('./views/activation/ActivationSuccess.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/activation/cancel',
    name: 'ActivationCancel',
    component: () => import('./views/activation/ActivationCancel.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/seller/:id',
    name: 'SellerProfile',
    component: () => import('./views/SellerProfile.vue')
  },
  {
    path: '/articles',
    name: 'Articles',
    component: () => import('./views/ArticlesView.vue')
  },
  {
    path: '/articles/:slug',
    name: 'ArticleDetail',
    component: () => import('./views/ArticleDetailView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('./views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Jeśli jest zapisana pozycja (np. przycisk wstecz), przywróć ją
    if (savedPosition) {
      return savedPosition
    }
    
    // Check if we're navigating back to an offers page from offer details
    if (to.path.startsWith('/offers') && from.path.startsWith('/offer/')) {
      // Let the component handle scroll restoration via sessionStorage
      return false
    }
    
    // Jeśli to strona ofert, sprawdź czy to tylko zmiana filtrów
    if (to.path.startsWith('/offers') && from.path.startsWith('/offers')) {
      // Sprawdź czy to tylko zmiana parametrów zapytania (query) lub filtrów w ścieżce
      const fromQueryKeys = Object.keys(from.query || {})
      const toQueryKeys = Object.keys(to.query || {})
      
      // Jeśli są jakieś parametry zapytania, to prawdopodobnie to filtry
      if (fromQueryKeys.length > 0 || toQueryKeys.length > 0) {
        return false
      }
      
      // Jeśli ścieżka się zmieniła, ale to tylko zmiana filtrów na stronie ofert,
      // nie przewijaj na górę
      if (to.path !== from.path) {
        return false
      }
    }
    
    // Jeśli to nowa strona (zmiana routingu), przewiń na górę
    if (to.path !== from.path) {
      return { top: 0, left: 0, behavior: 'smooth' }
    }
    
    // Jeśli to tylko zmiana parametrów URL na tej samej stronie (np. filtry wyszukiwania),
    // nie przewijaj na górę
    if (to.path === from.path) {
      // Sprawdź czy to tylko zmiana parametrów zapytania (query)
      const fromQueryKeys = Object.keys(from.query || {})
      const toQueryKeys = Object.keys(to.query || {})
      
      // Jeśli są jakieś parametry zapytania, to prawdopodobnie to filtry
      if (fromQueryKeys.length > 0 || toQueryKeys.length > 0) {
        return false
      }
    }
    
    // W przeciwnym razie nie zmieniaj pozycji (dla dynamicznych aktualizacji)
    return false
  }
})

// Route guard for authentication
router.beforeEach((to, from, next) => {
  const auth = useAuthStore()
  
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    // Store the intended destination before redirecting to login
    localStorage.setItem('intendedRoute', to.fullPath)
    // Redirect to login if trying to access protected route without authentication
    next('/login')
  } else if (to.path === '/login' && auth.isAuthenticated) {
    // Redirect to home if trying to access login while already authenticated
    next('/')
  } else {
    next()
  }
})

const pinia = createPinia()
const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(i18n)
app.component('GlobalNotification', GlobalNotification)

// Initialize Sentry for error tracking
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Logs
    enableLogs: true,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || '1.0.0',
    attachProps: true,
    logErrors: true,
    beforeSend(event) {
      // Only send events with level 'error' or 'fatal'
      if (event.level === 'error' || event.level === 'fatal') {
        return event
      }
      return null // Drop the event
    },
  })
}

// Initialize Microsoft Clarity for session recording
let clarityTracker = null

const initializeClarity = () => {
  if (import.meta.env.VITE_CLARITY_PROJECT_ID && import.meta.env.VITE_ENABLE_ANALYTICS === 'true') {
    Clarity.init(import.meta.env.VITE_CLARITY_PROJECT_ID)
    clarityTracker = window.clarity
    
    // Make tracker available globally for other components
    window.clarityTracker = clarityTracker
  }
}

// Listen for Clarity consent
window.addEventListener('klaro:consent', (event) => {
  if (event.detail?.services?.clarity === true) {
    initializeClarity()
  } else if (event.detail?.services?.clarity === false) {
    if (clarityTracker) {
      // Clarity doesn't have a direct stop method, but we can clear the global reference
      clarityTracker = null
      window.clarityTracker = null
    }
  }
})

// Interceptor axios do obsługi tokenów i refresh
axios.interceptors.request.use(config => {
  const auth = useAuthStore()
  if (auth.accessToken) {
    config.headers.Authorization = `Bearer ${auth.accessToken}`
  }
  return config
})

let isRefreshing = false
let failedQueue = []

function processQueue(error, token = null) {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

axios.interceptors.response.use(
  response => response,
  async error => {
    const auth = useAuthStore()
    const originalRequest = error.config
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function(resolve, reject) {
          failedQueue.push({ resolve, reject })
        })
          .then(token => {
            originalRequest.headers.Authorization = 'Bearer ' + token
            return axios(originalRequest)
          })
          .catch(err => {
            router.push('/login')
            return Promise.reject(err)
          })
      }

      originalRequest._retry = true
      isRefreshing = true
      
      // Dodaj timeout na refresh token
      const refreshTimeout = setTimeout(() => {
        isRefreshing = false
        processQueue(error, null)
      }, 5000) // 5 sekund timeout
      
      try {
        const success = await auth.refreshTokenIfNeeded()
        clearTimeout(refreshTimeout)
        if (success) {
          originalRequest.headers.Authorization = 'Bearer ' + auth.accessToken
          processQueue(null, auth.accessToken)
          return axios(originalRequest)
        } else {
          processQueue(error, null)
          // auth.refreshTokenIfNeeded() już obsługuje przekierowanie i powiadomienie
          return Promise.reject(error)
        }
      } catch (err) {
        clearTimeout(refreshTimeout)
        processQueue(error, null)
        // auth.refreshTokenIfNeeded() już obsługuje przekierowanie i powiadomienie
        return Promise.reject(error)
      } finally {
        clearTimeout(refreshTimeout)
        isRefreshing = false
      }
    }
    if (error.response && error.response.status === 401) {
      // Sprawdź czy to nie jest już próba refresh tokena
      if (!originalRequest.url?.includes('/auth/refresh')) {
        router.push('/login')
      }
    }

    return Promise.reject(error)
  }
)

axios.defaults.headers.common['Accept'] = 'application/ld+json'
axios.defaults.headers.post['Content-Type'] = 'application/ld+json'
axios.defaults.headers.put['Content-Type'] = 'application/ld+json'
axios.defaults.headers.patch['Content-Type'] = 'application/ld+json'

app.mount('#app') 